import React, { useState, useEffect } from 'react';

const CloseServiceModal = ({ isOpen, onClose, onConfirm, serviceName, loading = false }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Cerrar servicio continuo</h3>
          <p className="text-gray-700 mb-6">
            {serviceName
              ? `¿Está seguro de cerrar el servicio "${serviceName}"? No podrá agregar más registros de avance.`
              : 'Una vez cerrado, no podrá agregar más registros de avance.'}
          </p>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md disabled:opacity-50"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={loading}
              className="px-4 py-2 text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 rounded-md disabled:opacity-50"
            >
              {loading ? 'Cerrando...' : 'Cerrar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloseServiceModal;
